import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function Dolor() {
  const dolores = ['Llegás al entrenamiento sin saber exactamente qué ejercicio vas a dar', 'Tus jugadores no progresan porque no hay un orden claro de contenidos', 'Tenés grupos con edades o niveles mezclados y no sabés cómo manejarlo', 'Cuando falta gente o cambia el espacio perdés toda la planificación', 'No podés justificar tu valor como profe porque no tenés nada sistematizado', 'Los padres te cuestionan y no tenés herramientas para responderles con datos', 'Nadie ve tu trabajo porque no se refleja en resultados concretos y medibles', 'Terminás cada sesión agotado sin saber si realmente avanzaste algo'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-76">
      <div className="max-w-[800px] mx-auto" data-id="element-77">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-extrabold text-center text-gray-900 mb-12" data-id="element-78">
          Si sos profe de fútbol, esto
          <br className="hidden sm:block" data-id="element-79" /> te va a sonar conocido:
        </motion.h2>

        <div className="space-y-3 mb-16" data-id="element-80">
          {dolores.map((dolor, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="flex items-start gap-4 p-4 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-81">
              <div className="flex-shrink-0 mt-0.5" data-id="element-82">
                <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center" data-id="element-83">
                  <X className="w-4 h-4 text-red-600" data-id="element-84" />
                </div>
              </div>
              <p className="text-lg text-gray-700 font-medium" data-id="element-85">{dolor}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-86">
          <h3 className="text-2xl sm:text-3xl font-black text-gray-900 mb-8 px-4" data-id="element-87">
            "¿Cuántos entrenamientos más vas a improvisar?"
          </h3>

          <a href="#precio" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg font-bold text-white bg-f360-green hover:bg-f360-dark rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-88">
            👉 BASTA DE IMPROVISAR — QUIERO MI FÚTBOL 360
          </a>
        </motion.div>
      </div>
    </section>;
}